module.exports = __webpack_public_path__ + "img/spirit_h5.0f0949a8.webp";